import jwt_decode from "jwt-decode";

import StorageService from "./storage.service";


class JWTService extends StorageService {

    /**
     * Return the default storage key.
     *
     * @returns {string} The default storage key.
     */
    static get key() {
        return "token";
    }
    static get type_key() {
        return "type";
    }

    /**
     * Return the JWT from the local storage, if any.
     *
     * @returns {string} The JWT.
     */
    static getToken() {
        // return sessionStorage.getItem(this.key);
        return this.getFromLocalStorage(this.key);
    }
    static getTokenType() {
        return this.getFromLocalStorage(this.type_key);
    }

    /**
     * Set the JWT in the local storage.
     *
     * @param {string} token The JWT.
     */
    static setToken(token) {
        sessionStorage.setItem(this.key, token);
        this.setIntoLocalStorage(this.key, token);
    }

    static setTokenType(type) {
        this.setIntoLocalStorage(this.type_key, type);
    }

    /**
     * Remove the JWT from the local storage.
     */
    static removeToken() {
        sessionStorage.removeItem(this.key);
        this.removeFromLocalStorage(this.key);
    }

    static removeTokenType() {
        this.removeFromLocalStorage(this.type_key);
    }

    /**
     * Check whether the JWT has expired.
     *
     * @returns {boolean} Whether the JWT has expired.
     */
    static isExpired() {
        let token, payload;

        token = this.getToken();

        if (!token) {
            return true;
        }

        payload = jwt_decode(token);

        return new Date().getTime() >= new Date(payload.exp * 1000);
    }
}


export default JWTService;
